import Yup from '@fourthwall/utils/dist/yup'

import { variantPriceSchema } from '../../../../validators/productValidatorSchema'

export const validationSchema = Yup.object().shape({
  price: variantPriceSchema,
})
